import Image from '@app/components/Image'
import { IAttachment } from '@app/models/Attachment'
import { ImageSize } from '@app/models/enums'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import ShareToolbarButton from '../containers/ShareToolbarButtonContainer'
import './ImageLightbox.scss'

interface IImageLightboxProps {
  images: List<IAttachment>
  propertyId?: string
}

type ImageLightboxProps = IImageLightboxProps

interface IImageLightboxState {
  isLightboxOpen: boolean
  mainIndex: number
}

export default class ImageLightbox extends React.PureComponent<
  ImageLightboxProps,
  IImageLightboxState
> {
  constructor(props: ImageLightboxProps) {
    super(props)
    this.state = {
      isLightboxOpen: false,
      mainIndex: -1,
    }
    bindFunctions(this)
  }

  public show(selectedIndex: number) {
    this.setState({
      isLightboxOpen: true,
      mainIndex: selectedIndex,
    })
  }

  public render() {
    if (!this.state.isLightboxOpen) {
      return null
    }

    const hasMultipleImages = this.props.images.size > 1

    const toolbarButtons: React.ReactNode[] = []

    if (this.state.isLightboxOpen) {
      toolbarButtons.push(
        <a
          key='download-button'
          className='lightbox-toolbar-button'
          href={this._getImage(this.state.mainIndex).getUrl()}
          target='_blank'
          rel='noreferrer'
          title='Download'
        >
          <FontAwesomeIcon icon={['fal', 'download']} fixedWidth />
        </a>,
      )
      toolbarButtons.push(
        <ShareToolbarButton
          key='share-button'
          attachment={this._getImage(this.state.mainIndex)}
          propertyId={this.props.propertyId}
        />,
      )
    }

    return (
      <Lightbox
        mainSrc={this._getImage(this.state.mainIndex).getUrl()}
        nextSrc={
          hasMultipleImages
            ? this._getImage(this.state.mainIndex + 1).getUrl()
            : undefined
        }
        prevSrc={
          hasMultipleImages
            ? this._getImage(this.state.mainIndex - 1).getUrl()
            : undefined
        }
        onCloseRequest={this._closeLightbox}
        onMoveNextRequest={this._moveNext}
        onMovePrevRequest={this._movePrev}
        toolbarButtons={toolbarButtons}
        imageTitle={this._getImage(this.state.mainIndex).title}
        imageCaption={this._getImage(this.state.mainIndex).description}
      />
    )
  }

  private _closeLightbox() {
    const closeState = {
      isLightboxOpen: false,
    }

    this.setState(closeState)
  }

  private _getImage(index: number): IAttachment {
    return this.props.images.get(index % this.props.images.size)
  }

  private _moveNext() {
    const nextIndex = (this.state.mainIndex + 1) % this.props.images.size

    this.setState({
      mainIndex: nextIndex,
    })
  }

  private _movePrev() {
    const prevIndex =
      (this.state.mainIndex + this.props.images.size - 1) %
      this.props.images.size

    this.setState({
      mainIndex: prevIndex,
    })
  }
}
